// ** Third Party Components
import styled from "styled-components";
import DynamicSlashVideoIcon from "./DynamicSlashVideoIcon";

//##################################

const StyledPublisherEmptyStreamLayout = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
`;

const StyledPublisherAvatar = styled.img`
	height: 100%;
	margin: 0 auto;
`;

const IconContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;
const IconBackdrop = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 2;
`;

//##################################

const PublisherEmptyStreamLayout = ({ loggedUser }) => {
	return (
		<StyledPublisherEmptyStreamLayout>
			<StyledPublisherAvatar src={loggedUser.avatar} />
			<IconBackdrop>
				<IconContainer>
					<DynamicSlashVideoIcon customHeight="30px" slash />
				</IconContainer>
			</IconBackdrop>
		</StyledPublisherEmptyStreamLayout>
	);
};

export default PublisherEmptyStreamLayout;
